import {
  ERROR_CONTENT,
  GET_TOOL,
  GET_THERAPEUTIC_AREAS,
  GET_THERAPEUTIC_AREA,
  GET_DRUGS,
  GET_DRUG,
  GET_DRUG_VARIATIONS,
  GET_PATHOLOGIES,
  GET_PATHOLOGY,
  GET_CENTERS,
  GET_CENTER,
  GET_CONTACTS,
  GET_CONTACT,
  GET_CONGRESS_ITEM,
  GET_COMPANIES,
  GET_COMPANY,
} from '../actions/types';

const initialState = {
  error: null,
  tool: null,
  therapeuticAreas: null,
  therapeuticArea: null,
  drugs: null,
  drug: null,
  drugVariations: [],
  pathologies: null,
  pathology: null,
  centers: null,
  center: null,
  contacts: null,
  contact: null,
  congressItem: null,
  companies: null,
  company: null,
};

export default function contentReducer(state = initialState, action = {}) {
  switch (action.type) {
    case GET_TOOL:
      return { ...state, tool: action.payload };
    case GET_THERAPEUTIC_AREAS:
      return { ...state, therapeuticAreas: action.payload };
    case GET_THERAPEUTIC_AREA:
      return { ...state, therapeuticArea: action.payload };
    case GET_DRUGS:
      return { ...state, drugs: action.payload };
    case GET_DRUG:
      return { ...state, drug: action.payload };
    case GET_DRUG_VARIATIONS:
      return { ...state, drugVariations: action.payload || [] };
    case GET_PATHOLOGIES:
      return { ...state, pathologies: action.payload };
    case GET_PATHOLOGY:
      return { ...state, pathology: action.payload };
    case GET_CENTERS:
      return { ...state, centers: action.payload };
    case GET_CENTER:
      return { ...state, center: action.payload };
    case GET_CONTACTS:
      return { ...state, contacts: action.payload };
    case GET_CONTACT:
      return { ...state, contact: action.payload };
    case GET_CONGRESS_ITEM:
      return { ...state, congressItem: action.payload };
    case GET_COMPANIES:
      return { ...state, companies: action.payload };
    case GET_COMPANY:
      return { ...state, company: action.payload };
    case ERROR_CONTENT:
      return { ...state, error: action.payload };
    default:
      return state;
  }
}
